<template>
	<div
		class="fill-height"
		style="background-color: rgb(238 238 238);"
	>
		<dashboard-core-app-bar />

		<dashboard-core-drawer />

		<v-main>
			<v-row
				justify="center"
				align-content="center"
			>
				<v-col lg="11">
					<router-view />
				</v-col>
			</v-row>
		</v-main>

		<!--        <dashboard-core-settings/>-->
	</div>
</template>

<script>
import DashboardCoreAppBar from "./core/AppBar";
import DashboardCoreDrawer from "./core/Drawer";
export default {
	name: "DashboardIndex",

	components: {
		DashboardCoreAppBar,
		DashboardCoreDrawer,
	},

	data: () => ({
		expandOnHover: false,
	}),
};
</script>
